import React from "react"
import LinkButton from "../linkButton"

const Link = (props) => {
  const { children, mark } = props
  const { page, href } = mark

  const slug = page && page.slug && page.slug.current

  if (!slug && !href) return null

  return slug ? (
    <LinkButton to={slug} inline>
      {children}
    </LinkButton>
  ) : (
    <LinkButton href={href} inline>
      {children}
    </LinkButton>
  )
}

export default Link
